import React from 'react';
import { trackAddToCart } from '../../utils/pixel';
export function PriceBlock() {
  return <section id="precio" className="w-full py-20 px-6" style={{
    backgroundColor: '#1A1A1A'
  }} data-id="element-136">
      <div className="max-w-2xl mx-auto text-center" data-id="element-137">
        {/* Eyebrow */}
        <span className="inline-block text-xs font-semibold tracking-widest uppercase mb-6" style={{
        color: '#FF5A5F',
        fontFamily: 'Inter, sans-serif'
      }} data-id="element-138">
          Oferta de lanzamiento
        </span>

        {/* Product name */}
        <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold mb-4 leading-tight text-white" style={{
        fontFamily: 'Plus Jakarta Sans, sans-serif'
      }} data-id="element-139">
          Airbnb Superhost Spanish OS
        </h2>

        {/* Tagline */}
        <p className="text-lg mb-8" style={{
        color: '#9CA3AF',
        fontFamily: 'Inter, sans-serif'
      }} data-id="element-140">
          No es un gasto, es la inversión más económica que harás para proteger
          tu salud mental y tu calificación como anfitrión.
        </p>

        {/* Price card */}
        <div className="rounded-3xl p-8 mb-8 border border-[#2A2A2A]" style={{
        backgroundColor: '#242424'
      }} data-id="element-141">
          {/* What's included summary */}
          <div className="text-left mb-8 space-y-3" data-id="element-142">
            <div className="flex items-center gap-3" data-id="element-143">
              <span style={{
              color: '#FF5A5F'
            }} data-id="element-144">
                ✓
              </span>
              <span style={{
              color: '#D1D5DB',
              fontFamily: 'Inter, sans-serif'
            }} className="text-sm" data-id="element-145">
                Protocolo de Comunicación Asíncrona
              </span>
            </div>
            <div className="flex items-center gap-3" data-id="element-146">
              <span style={{
              color: '#FF5A5F'
            }} data-id="element-147">
                ✓
              </span>
              <span style={{
              color: '#D1D5DB',
              fontFamily: 'Inter, sans-serif'
            }} className="text-sm" data-id="element-148">
                Guía de Check-in Visual
              </span>
            </div>
            <div className="flex items-center gap-3" data-id="element-149">
              <span style={{
              color: '#FF5A5F'
            }} data-id="element-150">
                ✓
              </span>
              <span style={{
              color: '#D1D5DB',
              fontFamily: 'Inter, sans-serif'
            }} className="text-sm" data-id="element-151">
                Manual de la Casa "Sin Fricción"
              </span>
            </div>
            <div className="flex items-center gap-3" data-id="element-152">
              <span style={{
              color: '#FF5A5F'
            }} data-id="element-153">
                ✓
              </span>
              <span style={{
              color: '#D1D5DB',
              fontFamily: 'Inter, sans-serif'
            }} className="text-sm" data-id="element-154">
                El Cierre Maestro (reseñas de 5 estrellas)
              </span>
            </div>
            <div className="flex items-center gap-3" data-id="element-155">
              <span style={{
              color: '#FF5A5F'
            }} data-id="element-156">
                ✓
              </span>
              <span style={{
              color: '#D1D5DB',
              fontFamily: 'Inter, sans-serif'
            }} className="text-sm" data-id="element-157">
                Guía de Configuración en 10 Minutos
              </span>
            </div>
          </div>

          {/* Divider */}
          <div className="w-full h-px mb-8" style={{
          backgroundColor: '#2A2A2A'
        }} data-id="element-158" />

          {/* Price */}
          <div className="flex items-baseline justify-center gap-2 mb-2" data-id="element-159">
            <span className="text-6xl sm:text-7xl font-extrabold text-white" style={{
            fontFamily: 'Plus Jakarta Sans, sans-serif'
          }} data-id="element-160">
              $6.39
            </span>
            <span style={{
            color: '#9CA3AF',
            fontFamily: 'Inter, sans-serif'
          }} className="text-xl" data-id="element-161">
              USD
            </span>
          </div>
          <p style={{
          color: '#9CA3AF',
          fontFamily: 'Inter, sans-serif'
        }} className="text-sm mb-8" data-id="element-162">
            Precio único · Sin suscripciones · Acceso de por vida
          </p>

          {/* CTA Button */}
          <a href="https://www.oniyeyeo.com/cart/43011413868611:1" target="_blank" rel="noopener noreferrer" onClick={() => trackAddToCart()} className="block w-full text-center text-white font-bold text-lg px-8 py-5 rounded-xl shadow-lg transition-all duration-200 hover:shadow-xl hover:-translate-y-0.5 active:translate-y-0 mb-4" style={{
          backgroundColor: '#FF5A5F',
          fontFamily: 'Plus Jakarta Sans, sans-serif'
        }} onMouseEnter={e => e.currentTarget.style.backgroundColor = '#E84E53'} onMouseLeave={e => e.currentTarget.style.backgroundColor = '#FF5A5F'} data-id="element-163">
            ¡QUIERO AUTOMATIZAR MI AIRBNB AHORA!
          </a>

          {/* Trust badges */}
          <div className="flex flex-wrap justify-center gap-4 text-xs" style={{
          color: '#6B7280',
          fontFamily: 'Inter, sans-serif'
        }} data-id="element-164">
            <span className="flex items-center gap-1" data-id="element-165">🔒 Pago seguro</span>
            <span className="flex items-center gap-1" data-id="element-166">
              ⚡ Descarga inmediata
            </span>
            <span className="flex items-center gap-1" data-id="element-167">
              ♾️ Acceso de por vida
            </span>
          </div>
        </div>

        {/* Platforms */}
        <p style={{
        color: '#6B7280',
        fontFamily: 'Inter, sans-serif'
      }} className="text-sm" data-id="element-168">
          Compatible con Airbnb · VRBO · Booking.com · y más
        </p>
      </div>
    </section>;
}